export default {
  parseKolorColor(value) {
    switch (value) {
      case 'purple':
        return 'rgb(101, 69, 183)';
      case 'blue':
        return 'rgb(35, 152, 244)';
      case 'red':
        return 'rgb(255, 77, 91)';
      case 'yellow':
        return 'rgb(217, 155, 58)';
      default:
        return value;
    }
  },
};
